/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function UpdateIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path xmlns="http://www.w3.org/2000/svg" d="M23.9984 9.49333H14.9584L18.6117 5.73333C14.9717 2.13333 9.07838 2 5.43838 5.6C1.79838 9.21333 1.79838 15.04 5.43838 18.6533C9.07838 22.2667 14.9717 22.2667 18.6117 18.6533C20.425 16.8667 21.3317 14.7733 21.3317 12.1333H23.9984C23.9984 14.7733 22.825 18.2 20.4784 20.52C15.7984 25.16 8.19838 25.16 3.51838 20.52C-1.14829 15.8933 -1.18829 8.37333 3.49171 3.74667C8.17171 -0.88 15.6784 -0.88 20.3584 3.74667L23.9984 0V9.49333ZM12.665 6.66667V12.3333L17.3317 15.1067L16.3717 16.72L10.665 13.3333V6.66667H12.665Z" />
    </SvgIcon>
  );
}
